import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import { LocaleService } from "./services/storage.service";
import { VueReCaptcha } from "vue-recaptcha-v3";
import GlobalMixin from "@/mixins/GlobalMixin";
import baseModule from "./store/base.module";
import { formatDate } from "@/utils";
import { Component } from "vue-property-decorator";

Component.registerHooks(["beforeRouteLeave"]);

if (!baseModule.blockRECAPTCHA) {
  Vue.use(VueReCaptcha, {
    siteKey: process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY,
    loaderOptions: {
      autoHideBadge: true,
    },
  });
}
Vue.mixin(GlobalMixin);

Vue.filter("formatDate", formatDate);
Vue.filter("nullable", (v: any) => v || "-");
Vue.filter("formatDateTime", (v: string) => formatDate(v, "dd.MM.yyyy HH:mm"));

import "./assets/css/roboto.css";
import "./assets/css/index.scss";

LocaleService.init();

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
